import React, { useRef, useState } from "react";
import { TabsRef } from "flowbite-react";
import {
  BaseModal,
  BaseModalBody,
  BaseModalHeader,
  Tabs,
} from "@src/common/components";
import { OverridePODTab } from "./OverridePODTab";
import { OverrideStopCompletedTimesTab } from "./OverrideStopCompletedTimesTab";
import { ManualArrivalOverrideTab } from "./ManualArrivalOverrideTab/ManualArrivalOverrideTab";
import { useOverridePODShipment } from "./hooks/useOverridePODShipment";

type Props = {
  isModalOpen: boolean;
  onClose: () => void;
  shipmentId?: string;
};

const OverridePODModal = ({ isModalOpen, onClose, shipmentId }: Props) => {
  const tabsRef = useRef<TabsRef>(null);
  const [activeTab, setActiveTab] = useState<number>(0);

  const { shipment, loading } = useOverridePODShipment({
    shipmentId,
    skip: !isModalOpen,
  });

  const handleActiveTabChange = (index: number) => {
    setActiveTab(index);
  };

  return (
    <BaseModal isOpen={isModalOpen} onClose={onClose} size="auto">
      <div className="w-[900px] max-w-full">
        <BaseModalHeader>
          Override POD & Completion Times
          {shipment?.order?.displayId &&
            ` - Order #${shipment.order.displayId}`}
        </BaseModalHeader>
        <BaseModalBody className="p-4">
          {loading ? (
            <div className="flex justify-center py-8">
              <p className="text-sm text-gray-500">Loading...</p>
            </div>
          ) : (
            <Tabs.Group
              aria-label="Override POD tabs"
              ref={tabsRef}
              onActiveTabChange={handleActiveTabChange}
              className="gap-2 flex justify-center"
            >
              <Tabs.Item
                title="Signed By & Delivered At"
                key="pod-override"
                active={activeTab === 0}
              >
                <OverridePODTab selectedShipment={shipment} onClose={onClose} />
              </Tabs.Item>
              <Tabs.Item
                title="Stop Completion Times"
                key="stop-times"
                active={activeTab === 1}
              >
                <OverrideStopCompletedTimesTab
                  selectedShipment={shipment}
                  onClose={onClose}
                />
              </Tabs.Item>
              <Tabs.Item
                title="Override Arrival Time"
                key="manual-arrival"
                active={activeTab === 2}
              >
                <ManualArrivalOverrideTab
                  shipment={shipment}
                  onClose={onClose}
                />
              </Tabs.Item>
            </Tabs.Group>
          )}
        </BaseModalBody>
      </div>
    </BaseModal>
  );
};

export default OverridePODModal;
